<template>
  <HomeLayout>
    <b-row class="column-border-container">
      <!--ESSENTIAL INFO PANELS-->
      <b-col
        v-for="data in product.essentialInfoData"
        :key="data.id"
        class="column-border card-col col-12 col-lg"
      >
        <a class="vtd-card vtd-animate-shake" @click="handleProductClick(data)">
          <div class="navigation-block">
            <h4 class="nav-title-center text-uppercase">
              {{ getTitle(data.infoType) }}
            </h4>

            <div class="nav-text-center">
              <i
                v-if="product.productType !== 'tour'"
                class="material-icons vtd-icon-7"
                >{{ getIcon(data.productType) }}</i
              >
              <TourIcon
                v-if="product.productType === 'tour'"
                :brick-id="product.brickId"
                :tour-type="product.tourType"
              />
            </div>
          </div>
          <div class="vtd-card-footer nav-text-center d-none d-lg-block">
            <p class="vtd-home-btn text-center">View Now</p>
          </div>
        </a>
      </b-col>
    </b-row>
    <b-row>
      <b-col class="home-nav-container-header">
        <h4>{{ product.productTitle }}</h4>
      </b-col>
    </b-row>
    <GroundProductModal ref="GroundProductModalRef" />
    <HomeBackBtns />
  </HomeLayout>
</template>

<script>
import HomeLayout from "@/partials/home-layout";
import TourIcon from "@/partials/tour-icon";
import GroundProductModal from "@/modules/navigation/modals/ground-product-modal";
import { mapGetters } from "vuex";
export default {
  components: {
    HomeLayout,
    TourIcon,
    GroundProductModal,
  },
  data() {
    return {
      product: null,
      iconsMap: {
        hotel: "hotel",
        tour: "explore",
        transfer: "rv_hookup",
        vehicle: "directions_car",
        rail: "train",
      },
    };
  },
  computed: {
    ...mapGetters({
      getProductSpecific: "navigation/getProductSpecific",
    }),
  },
  watch: {
    itineraryRaw: async function () {
      this.renderPanels();
    },
  },
  created() {
    this.renderPanels();
  },
  methods: {
    renderPanels() {
      this.product = this.getProductSpecific.find(
        (el) => el.id === this.$route.params.id
      );
    },
    getTitle(infoType) {
      let title = "Essential Information";
      // product info
      if (infoType === "product") {
        title = `Essential ${
          this.product.productType.charAt(0).toUpperCase() +
          this.product.productType.slice(1)
        } Information`;
        if (this.product.productType === "tour") {
          title = `Essential ${
            this.product.tourType.charAt(0).toUpperCase() +
            this.product.tourType.slice(1)
          } Information`;
        }
      }
      if (infoType === "checkin") {
        title = "Action Required";
      }
      return title;
    },
    async handleProductClick(data) {
      await this.$refs.GroundProductModalRef.showModal(data);
    },
    getIcon(type) {
      let icon = "info";
      if (type && this.iconsMap[type]) {
        icon = this.iconsMap[type];
      }
      return icon;
    },
  },
};
</script>
<style lang="scss" scoped>
.column-border-container {
  background-color: rgba(232, 232, 232, 0.922);
}
</style>
